import { render } from "./OptionThree.vue?vue&type=template&id=c01195fe&scoped=true"
import script from "./OptionThree.vue?vue&type=script&lang=js"
export * from "./OptionThree.vue?vue&type=script&lang=js"

import "./OptionThree.vue?vue&type=style&index=0&id=c01195fe&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01195fe"]])

export default __exports__